import { MessageHandlerBase } from "./MessageHandlerBase";
const ManageAccountsAppEvent = "ConsumerCenterManageAccounts";
export default class ManageAccountsHandler extends MessageHandlerBase {
    handle(message) {
        if (!this.almeState.sessionExpired && this.almeState.history.length) {
            this.sendAppEvent(message, ManageAccountsAppEvent);
        }
    }
    createApiParams(message) {
        //the implemenatation has to be changed little bit
        // const apiParams = super.createApiParams(message);
        // if(apiParams.UserObj === undefined || apiParams.UserObj === null){
        //   /* eslint-disable sonarjs/no-duplicated-branches */
        //     /* eslint-disable  @typescript-eslint/no-non-null-assertion */
        //   apiParams.UserObj = this.appConfig.main.userMetadata as (CBUserMetadata | undefined);
        //  }
        return super.createApiParams(message);
    }
}
